/**
 * @file index.tsx
 * @module app/modules/uProcure/products/index
 * @description Implements the index interface for UProcure operations.
 *
 * @author Rocket Technologies Ltd
 * @copyright 2026 Rocket Technologies Ltd. All rights reserved.
 * @since 1.1.1
 * @version 1.2.5
 */

import { Navigate, Outlet, Route, Routes } from "react-router-dom";
import { PageLink, PageTitle } from "../../../../_admin/layout/core";
import AddNewProduct from "./add-new-products";
import ManageProducts from "./master-products";
import ViewProductDetails from "./view-product-details";
import MasterProducts from "./master-products";
// import AddNewProducts from './add-new-products'
// import EditProduct from "./edit-product/edit-product";
import EditProduct from "./edit-master-product/edit-products";
import EditProductVariant from "./edit-product-variant/edit-products";
const productBreadCrumbs: Array<PageLink> = [
  {
    title: 'UProcure',
    path: '/UProcure',
    isSeparator: false,
    isActive: false,
  },
  {
    title: 'Products',
    path: '/products',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
];
const UProcureProductsPage = () => {
  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route path="*" element={<Navigate to="/error/404" />} />
        <Route
          path="add-new-product"
          element={
            <>
              <PageTitle breadcrumbs={productBreadCrumbs}>
                Add new product
              </PageTitle>
              <AddNewProduct />
            </>
          }
        />
        <Route
          path="manage-products"
          element={
            <>
              <PageTitle breadcrumbs={productBreadCrumbs}>
                Manage Products
              </PageTitle>
              <ManageProducts />
            </>
          }
        />
        <Route
          path="master-products"
          element={
            <>
              <PageTitle breadcrumbs={productBreadCrumbs}>
                Master products
              </PageTitle>
              <MasterProducts />
            </>
          }
        />
        <Route
          path="master-products/view-product-details"
          element={
            <>
              <PageTitle breadcrumbs={productBreadCrumbs}>
                View Product Details
              </PageTitle>
              <ViewProductDetails />
            </>
          }
        />
        <Route
          path="edit-product"
          element={
            <>
              <PageTitle breadcrumbs={productBreadCrumbs}>
                Edit Product
              </PageTitle>
              <EditProduct />
            </>
          }
        />
        <Route
          path="edit-product-variant"
          element={
            <>
              <PageTitle breadcrumbs={productBreadCrumbs}>
                Edit Product Variant
              </PageTitle>
              <EditProductVariant />
            </>
          }
        />
      </Route>
      <Route index element={<Navigate to="products/add-new-product" />} />
    </Routes>
  );
};
export default UProcureProductsPage;
